export default "__VITE_PUBLIC_ASSET__53aef1b8__"